module.exports = __webpack_public_path__ + "img/doctor-avatar.9e08e478.svg";